import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import SEOContentSection from './components/SEOContentSection';
import FeaturedArticles from './components/FeaturedArticles';
import CTASection from './components/CTASection';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || '';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Itaobuy Spreadsheet Italia',
  url: siteUrl,
  description: 'Itaobuy Spreadsheet Italia: il database completo e aggiornato per lo shopping online. Guide, recensioni, categorie prodotto come Shoes, Hoodies, T-Shirts, Jackets e molto altro.',
  inLanguage: 'it',
  publisher: {
    '@type': 'Organization',
    name: 'Itaobuy Spreadsheet',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={jsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <SEOContentSection />
        <FeaturedArticles />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}